import jsbridge from '@xpeng/js-bridge';
import axios from 'axios';
import UnionAxios from '../utils/union-axios'
import { isXPApp } from '../utils/constants'
import { getPlatform, isInApp } from '../utils/common';

const BUSINESS_SUCCESS_CODE = 200;
const NETWORK_TIMEOUT_SECOND = 10;
const baseUrl = '/biz';
const baseUrl1 = '';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let env = 'test';
let apiDomain = '';

if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
  env = 'deploy';
  apiDomain = ''; //'https://xmart.deploy-test.xiaopeng.com'
} else if (window.location.href.indexOf('static.xiaopeng.com') !== -1) {
  env = 'product';
  apiDomain = ''; //'https://apps.xiaopeng.com'
}
export interface ResponseType<T> {
  msg: string;
  code: number;
  data: T;
}
class NotInAppError { }
// 设置请求超时
class NetworkTimeoutMsg { }
const networkTimeoutMsg = new NetworkTimeoutMsg();
function getNetworkTimeoutPromise(): Promise<NetworkTimeoutMsg> {
  return new Promise((resolve): void => {
    setTimeout((): void => {
      resolve(networkTimeoutMsg);
    }, NETWORK_TIMEOUT_SECOND * 1000);
  });
}

// 通过bridge发起app请求
function getNetworkRequestPromise<T, P>(
  url: string,
  params?: T,
  method: string = 'GET',
  useBase?: boolean
): Promise<ResponseType<P>> {
  let urlPath: string = url;
  if (method === 'GET' && params && getPlatform() === 'android') {
    const keys = Object.keys(params);
    keys.length &&
      (urlPath +=
        '?' +
        keys
          .map((key): string => {
            return `${key}=${params[key]}`;
          })
          .join('&'));
  }
  const realUrl = `${apiDomain}${useBase ? baseUrl1 : baseUrl}${urlPath}`;
  console.log('准备请求', realUrl, params, method, apiDomain);

  if (!isInApp()) {
    return Promise.reject(new NotInAppError());
  }
  return jsbridge
    .callHandler('request', {
      url: realUrl,
      options: {
        method,
        body: params
      }
    })
    .then(
      (res: ResponseType<P>): ResponseType<P> => {
        console.log(
          '响应请求',
          realUrl,
          params,
          method,
          JSON.stringify(res, null, 2)
        );
        return res;
      }
    );
}

function getUnionAxiosRequestPromise<T, P>(
  url: string,
  params?: T,
  method: string = 'GET',
): Promise<ResponseType<P>> {
  const request = {
    'GET': UnionAxios.get,
    'POST': UnionAxios.post,
  }[method]
  const realUrl = `${url.replace('/v5', '/web-h5')}`

  if (!request) {
    console.error('请求方式有误：', method);
    return {} as any;
  }

  // @ts-ignore
  return request(realUrl, params).then(
    (res: ResponseType<P>): ResponseType<P> => {
      console.log(
        '响应请求',
        url,
        params,
        method,
        JSON.stringify(res, null, 2)
      );
      return res;
    }
  ).catch((err) => {
    console.log('getUnionAxiosRequestPromise error', err);
  })
}

function getRequest() {
  if (isXPApp) {
    return getNetworkRequestPromise;
  }
  return getUnionAxiosRequestPromise;
}

type FetchFuc<T, P> = (
  url: string,
  params?: T,
  method?: string,
  useBase?: boolean
) => Promise<ResponseType<P>>;
type Method =
  | 'GET'
  | 'get'
  | 'delete'
  | 'DELETE'
  | 'head'
  | 'HEAD'
  | 'options'
  | 'OPTIONS'
  | 'post'
  | 'POST'
  | 'put'
  | 'PUT'
  | 'patch'
  | 'PATCH'
  | 'link'
  | 'LINK'
  | 'unlink'
  | 'UNLINK'
  | undefined;

function Ajax(url, params?, method = 'GET'): Promise<ResponseType<any>> {
  console.log('Ajax',url);
  return new Promise((resolve, reject): void => {
    method = method.toUpperCase();
    axios({
      headers: {
        'Content-Type': 'application/json',
        'logan': 'test',
        'XP-Client-Type': '2',
        'XP-Uid': '7803830',
        'XP-Appid': 'xp_xmart_ios',
        'XP-Client': 'br=Apple;cn=AppStore;cp=ARM64E;cr=1;di=ACD7023D-A800-4056-A325-DCD3E66D9183;gp=23.164969`113.409104```020`440106;ma=;me=127866785792;mo=iPhone 13;no=46001;nt=Wifi;pn=com.tentcoo.XiaoPengQiCheEnterprise;re=1125*2436;ro=iOS15.1.1;st=2;sv=15.1.1;t=1639970412225;ve=4.0.0',
        'websso': 'test',
        'XP-Nonce': '',
        'XP-Signature': '',
        'XP-Timestamp': '1619593894'
      },
      url: 'http://localhost:3000' + url,
      data: method !== 'GET' ? params : {},
      params: method === 'GET' ? params : {},
      method: method as Method,
    })
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      .then(response => {
        
        resolve(response.data as ResponseType<any>);
      })
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      .catch(err => {
        reject(err);
      });
  });
}

// 整合超时以及发起请求
export default function request<T, P>(
  url: string,
  params?: T,
  method = 'GET',
  useBase?: boolean
  // mock方法
  // mockFetch?: FetchFuc<T, P>
): Promise<P> {
  // debugger
  let fetchFunc: FetchFuc<T, P>;
  // console.log(process.env.NODE_ENV);
  // console.log(process.env);
  if (process.env.NODE_ENV === 'development' && process.env.MOCK) {
    fetchFunc = Ajax;
  } else {
    fetchFunc = getRequest();
  }
  // 通过Promise.race以实现超时设置
  return Promise.race([
    fetchFunc(url, params, method, useBase),
    getNetworkTimeoutPromise()
  ]).then((value: any): any => {
    if (value instanceof NetworkTimeoutMsg) {
      throw new Error('网络超时');
    }
    if (value instanceof NotInAppError) {
      throw new Error('请求方式不对');
    } else {
      if (value.code === BUSINESS_SUCCESS_CODE) {
        return value.data;
      }
      console.log('非200业务接口返回', value, 'from:', url, params, method);
      throw new Error(value.msg);
    }
  });
}
